export default "__VITE_ASSET__28cafcdf__"